module.exports = __webpack_public_path__ + "static/media/selected_dealers.bdbf56e1.svg";